import { type Constructor } from '../types';
import { type KeyPath } from '../collaboration/DataStoreRecordBehaviors';

// Behaviors for objects which render via a React component outside the canvas.
function ExternalContentBehaviors(Base: Constructor<fabric.Object>): any {
  return class extends Base {
    // Hook set operations and update the React component position if
    // necessary.
    _set(keyOrPath: KeyPath, value: any) {
      super._set(keyOrPath, value);
      this.updateExternalContent(keyOrPath);
      return this;
    }

    updateExternalContent(keyOrPath: KeyPath) {
      if (typeof keyOrPath !== 'string') return;

      if (
        [
          'top',
          'left',
          'width',
          'height',
          'scaleX',
          'scaleY',
          'z',
          'angle',
        ].includes(keyOrPath)
      ) {
        this.canvas?.externalContent?.positionContainer(this);
      }

      if (['width', 'height', 'scaleX', 'scaleY', 'fill'].includes(keyOrPath)) {
        // We need to re-render when a property changes that may affect how
        // the external content renders itself.
        this.canvas?.externalContent?.render(this);
      }
    }
  };
}

export default ExternalContentBehaviors;
